<template>
  <div>
    <svg
      :height="radius * 2"
      :width="radius * 2"
      style="transform: rotate(-90deg);">
      <circle
        stroke="#FFD6A6"
        :stroke-dasharray="circumference + ' ' + circumference"
        :style="{ strokeDashoffset: strokeDashoffset, transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease' }"
        :stroke-width="stroke"
        fill="transparent"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"/>
    </svg>
    <slot ></slot>
  </div>
</template>

<script>
export default {
  name: 'progress-ring',
  props: {
    radius: Number,
    progress: Number,
    stroke: Number
  },
  data () {
    const normalizedRadius = this.radius - this.stroke * 2
    const circumference = normalizedRadius * 2 * Math.PI

    return {
      normalizedRadius,
      circumference
    }
  },
  computed: {
    strokeDashoffset () {
      return this.circumference - this.progress / 60 * this.circumference
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/xbb/components/ProgressRing.vue